import { render, staticRenderFns } from "./edit-quiz-questions.html?vue&type=template&id=4791e461&scoped=true&external"
import script from "./edit-quiz-questions.vue?vue&type=script&lang=js"
export * from "./edit-quiz-questions.vue?vue&type=script&lang=js"
import style0 from "./edit-quiz-questions.css?vue&type=style&index=0&id=4791e461&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4791e461",
  null
  
)

export default component.exports